module.exports = __webpack_public_path__ + "img/rain_3.277e32db.png";